import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGas: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconGas"><Path d="M14.25 20.25H15.25M14.25 20.25V9.75M14.25 20.25H3.75M14.25 9.75V6.75C14.25 5.09315 12.9069 3.75 11.25 3.75H6.75C5.09315 3.75 3.75 5.09315 3.75 6.75V20.25M14.25 9.75H14.75C16.4069 9.75 17.75 11.0931 17.75 12.75V15.5C17.75 16.4665 18.5335 17.25 19.5 17.25C20.4665 17.25 21.25 16.4665 21.25 15.5V9.33609C21.25 8.48563 20.889 7.67513 20.2569 7.1062L18.75 5.75M2.75 20.25H3.75M11.25 9.75H6.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconGas;
